// extracted by mini-css-extract-plugin
export var footer = "_lx-5";
export var fulfillmentInput = "_lx-0";
export var shipDateInput = "_lx-1";
export var shipmentModal = "_lx-2";
export var shipmentModalContent = "_lx-3";
export var tableContainer = "_lx-4";